import React from 'react';
import { Link } from 'react-router-dom';
import { LineChart } from 'lucide-react';
import { APP_NAME, LOGO_ICON } from '../../constants/appConstants';

const Footer = () => {
  return (
    <footer className="bg-gray-50 border-t border-gray-100">
      <div className="container mx-auto px-4 py-8">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="flex items-center mb-4 md:mb-0">
            <div className="h-8 w-8 rounded-lg flex items-center justify-center">
              <img src={LOGO_ICON} alt={`${APP_NAME} Logo`} className="h-8 w-8 object-contain" />
            </div>
            <span className="ml-2 font-bold text-gray-800">{APP_NAME}</span>
          </div>
          <div className="flex space-x-6 text-sm text-gray-500 mb-4 md:mb-0">
            <span className="hover:text-primary-600">
              Powered by 
              <a href="https://www.ngombe.org" className="text-primary-600" target="_blank" rel="noopener noreferrer">
                  www.ngombe.org
              </a>
            </span>
          </div>
          <div className="text-sm text-gray-500">
            &copy; {new Date().getFullYear()} {APP_NAME}. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
